






















import { Component, Vue } from "vue-property-decorator";
import Carousel from "@/components/home/Carousel.vue";
import About from "@/components/home/About.vue";
import ImportantDates from "@/components/home/ImportantDates.vue";
import Chairmen from "@/components/home/Chairmen.vue";
import OrganizingCommittee from "@/components/home/OrganizingCommittee.vue";

import Topics from "@/components/home/Topics.vue";
import InvitedSpeakers from "@/components/home/InvitedSpeakers.vue";
import ScientificCommittee from "@/components/home/ScientificCommittee.vue";
import Publication from "@/components/home/Publication.vue";
import Programme from "@/components/home/Programme.vue";
import Venue from "@/components/home/Venue.vue";
import { me } from "../graphql/auth";
import Sponsors from "../components/home/Sponsors.vue";

@Component({
  components: {
    Carousel,
    About,
    ImportantDates,
    Chairmen,
    OrganizingCommittee,
    Topics,
    InvitedSpeakers,
    ScientificCommittee,
    Publication,
    Programme,
    Venue,
    Sponsors,
  },
  apollo: {
    me() {
      return { query: me, skip: true, variables: { conference: "" } };
    },
  },
})
export default class HomeView extends Vue {
  get conference() {
    return this.$store.getters.getConferenceId;
  }

  async mounted() {
    window.scrollTo(0, 0);
    const token: any = localStorage.getItem("token");
    const user: any = localStorage.getItem("user");

    this.$apollo.queries.me.setVariables({ conference: this.conference });
    this.$apollo.queries.me.skip = false;
    await this.$apollo.queries.me
      .refetch()
      .then((res) => {
        this.$store.commit("setUser", res.data.me);
        this.$store.commit("setToken", token);
        this.$store.commit("authenticate", true);
      })
      .catch((err: any) => {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
      });
  }
}
